export default __webpack_public_path__ + "media/Beverage-Coffee.75a7c219.png";